import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getRole } from '../../../../reducers';
import { can } from '../../../../services';
import moment from 'moment';
import UserDetailsElement from 'components/users/UserDetailsElement';
import UserDetailsRow from 'components/users/UserDetailsRow';
import { Button } from 'react-toolbox';
import DatePicker from 'components/DatePicker';
import styles from 'styles/input.scss';
import { updateUserBadge, addEventToEmployee, addEventToEstimator } from 'actionCreators';
import { visibleFor } from 'components/Auth';
import S from './styles.scss';
import { isOverdue } from '../../../../utils/dateUtils.js';

const EditCtrl = visibleFor('update', 'badge', ({ isEditable, onEdit, onSave }) =>
  <Button
    className={S.editBtn}
    label={isEditable ? 'Save Badge' : 'Edit Badge'}
    onClick={isEditable ? onSave : onEdit}
    ripple={false}
    neutral={false}
    flat
  />,
);

const inputStyle = `${styles.inputElement} ${S.inputElement}`;

class UserDetailsBadgeInfo extends React.Component {
  constructor(props) {
    super(props);
    const badge = (this.props.user && this.props.user.badge) || {};
    this.state = {
      isEditable: false,
      number: badge.number || '',
      expiration: badge.expiration || '',
      badgeLink: badge.badge_link || '',
      errors: {},
    };
  }

  getBadgeDiff = () => {
    const { user } = this.props;
    const diff = {};
    let currBadge = user.badge || null;
    if (!currBadge) currBadge = { expiration: null, number: null };
    ['expiration', 'number'].forEach((key) => {
      if (currBadge[key] !== this.state[key]) diff[key] = [currBadge[key], this.state[key]];
    });
    return diff;
  }

  handleEdit = () => this.setState({ isEditable: true });

  handleSave = () => {
    const { user, type } = this.props;
    const { number } = this.state;
    const expiration = moment(this.state.expiration, 'MM/DD/YYYY').toISOString();
    const badgeDiff = this.getBadgeDiff();
    const eventProps = {
      name: `Update ${type === 'estimator' ? 'Estimator' : 'Empployee'} Profile`,
      kind: 'update_profile',
      data: { updates: badgeDiff },
    };
    this.props.updateUserBadge(user.user_id, { number, expiration })
      .then(() => {
        if (type === 'estimator') this.props.addEventToEstimator(user.id, eventProps);
        else this.props.addEventToEmployee(user.id, eventProps);
        this.setState({ isEditable: false, errors: {} });
      })
      .catch(({ errors }) => this.setState({ errors }));
  }

  handleBadgeNumber = event => this.setState({ number: event.target.value || '' });

  handleBadgeExpiration = val => this.setState({ expiration: val });

  render = () => {
    const { isEditable, number, expiration, errors, badgeLink } = this.state;
    const { role, authUser, user } = this.props;
    const badgeDate = (expiration || '').toString() || '';
    let isBadgeOverdue = false;
    if (badgeDate) {
      const dateObj = new Date(badgeDate);
      const dateISO = dateObj.toISOString();
      isBadgeOverdue = isOverdue(dateISO);
    }
    let badgeTitle = 'badge expiration';
    if (isBadgeOverdue) badgeTitle = `${badgeTitle} ***expired***`;
    if (!can(role, 'view', 'badge', { user_id: authUser.id, obj_id: user.user_id })) return null;
    return (<div>
      <UserDetailsRow
        title="Badge Details"
        subtitle={<EditCtrl
          isEditable={isEditable}
          onEdit={this.handleEdit}
          onSave={this.handleSave}
        />}
      >
        <UserDetailsElement isValueOptional={!isEditable} title="badge number" value={number}>
          {isEditable && <div className={errors.number ? styles.errored : ''}>
            <input
              type="text"
              className={inputStyle}
              value={number}
              onChange={this.handleBadgeNumber}
            />
            <div className={styles.error}>
              <span className={S.errorMsg}>{errors.number}</span>
            </div>
          </div>}
        </UserDetailsElement>
        <UserDetailsElement isValueOptional={!isEditable} title={badgeTitle} value={badgeDate}>
          {isEditable && <DatePicker
            className={S.datepicker}
            value={badgeDate}
            onChange={this.handleBadgeExpiration}
            error={errors.badgeDate}
          />}
        </UserDetailsElement>
        <UserDetailsElement title="Badge Link" value={badgeLink}>
          <a href={`http://${badgeLink}`} target="_blank" rel="noopener noreferrer">
            {badgeLink}
          </a>
        </UserDetailsElement>
      </UserDetailsRow>
    </div>);
  }
}

UserDetailsBadgeInfo.defaultProps = { type: '' };

UserDetailsBadgeInfo.propTypes = {
  authUser: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  role: PropTypes.string.isRequired,
  user: PropTypes.shape({
    badge: PropTypes.shape({
      number: PropTypes.string.isRequired,
      expiration: PropTypes.string.isRequired,
    }),
    user_id: PropTypes.number.isRequired,
  }).isRequired,
  type: PropTypes.string,
  updateUserBadge: PropTypes.func.isRequired,
  addEventToEmployee: PropTypes.func,
  addEventToEstimator: PropTypes.func,
};

export default connect(
  state => ({ role: getRole(state), authUser: state.user }),
  { updateUserBadge, addEventToEmployee, addEventToEstimator },
)(UserDetailsBadgeInfo);



// WEBPACK FOOTER //
// ./client/app/shared/components/users/UserDetailsBadgeInfo/index.jsx